// extracted by mini-css-extract-plugin
module.exports = {"description":"CompanyProfile_description__5r-hQ","buttonWrapper":"CompanyProfile_buttonWrapper__1sb15","button":"CompanyProfile_button__1w_YQ"};